import {IconProps} from "./types";

export const AddNoteIcon = (props: IconProps) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6667 8H5.33333M8 10.6667V5.33333M14 8C14 11.3137 11.3137 14 8 14C7.22867 14 6.49134 13.8545 5.81397 13.5893C5.55939 13.4897 5.28398 13.447 5.0144 13.4924L2.46184 13.9222C2.23583 13.9603 2.03971 13.7642 2.07778 13.5382L2.50765 10.9856C2.55305 10.716 2.51032 10.4406 2.41067 10.186C2.14555 9.50866 2 8.77133 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
        stroke={props.stroke || "#9CA3AF"}
        strokeWidth="1.33333"
        strokeLinecap="round"
      />
    </svg>
  );
};
